import { Injectable } from '@angular/core';

@Injectable()
export class RecordsService {

  constructor() { }

  RECORDS:Array<string> = [
    'No presento antecedentes patológicos',
    'Hipertensión arterial',
    'Diabetes',
    'Hipo/hipertiroidismo',
    'Tabaquismo',
    'Alcoholismo',
    'Drogas',
    'ALERGIA A MEDICAMENTOS ',
    'Accidente cerebrovascular',
    'Otras Convulsiones/Epilepsia',
    'Migraña/cefalea',
    'Deterioro cognitivo',
    'Infarto',
    'Arritmias',
    'Colocación de stents',
    'Cirugía cardiovascular',
    'Marcapasos',
    'Asma',
    'Enfisema pulmonar',
    'Hemorragia digestiva',
    'Gastritis/úlcera gástrica',
    'Hepatitis',
    'Insuficiencia hepática',
    'Cirrosis',
    'Trastornos de la coagulación',
    'Linfoma/leucemia',
    'Neutropenia',
    'Enfermedades de transmisión sexual',
    'Tuberculosis',
    'ENF. ONCOLÓGICAS ',
    'Enfermedades Congénitas/Hereditarias',
    'CIRUGÍAS PREVIAS ',
    'Anticoagulación ',
    'Quimioterapia',
    'Corticoides',
    'Bajo peso',
    'Sobrepeso',
    'Recién nacido prematuro',
    'Infecciones durante el embarazo ',
    'Enfermedad genética',
    'Convulsiones febriles',
    'Retraso madurativo',
    'Cardiopatía congénita',
    'Broncoespasmos a repetición',
    'Alergia a la leche de vaca',
    'Enfermedad celíaca',
    'Inmunodeficiencias'
  ]

  getStringRecords(ids){
    var recordsString:Array<string> = [];
    for (let index = 0; index < ids.length; index++) {
      recordsString.push( this.RECORDS[parseInt(ids[index],10)]);
    }
    return recordsString;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/records/records.service.ts